export default {
    getToken: (state) => {
        return state.authentication.token == '' || state.authentication.token == null ? localStorage.getItem('coin') : state.authentication.token
    },
    getActiveUser: (state) => {
        let user = {...state.activeUser}

        // Capitalize user's name
        if (typeof user.name === 'string')
            user.name = user.name.charAt(0).toUpperCase() + user.name.slice(1);
        return user
    },
    allow: (state) => (role) => {
        if (typeof role == 'undefined' || role == null || role == '') {
            return true
        } else if (state.activeUser.role == 'superadmin') {
            return true
        } else if (state.activeUser.role == 'admin') {
            return true
        } else if (state.activeUser.role == 'editor' && role == 'editor') {
            return true
        } else {
            return false
        }
    }
}